import React, { useState, useEffect, useCallback } from 'react';
import { useSpring } from 'react-spring';
import { Button } from '../../components/Button';
import * as Ui from './styles';

// TODO: documentar
function PromptAlert({
  // informa que o prompt está sendo visível ou não
  isOpen = false,
  // informa que está ocorrendo um processamento e o botão Ok deve refletir isto como microinteração
  isLoading = false,
  // um dos componentes de ícones
  iconComponent,
  // tamanho do ícone
  iconSize = 40,
  // o texto a ser exibito
  text,
  // evento de acionamento do botão de ok ou TODO: de toque fora da tela ou ESC
  onOk,
}) {
  // state
  const [isVisible, setVisibility] = useState(false);

  // callbacks
  const handleExitByDOMEvent = useCallback((event) => {
    if (event.keyCode === 27) {
      setVisibility(false);
    }
  }, []);

  // on open or close
  useEffect(() => {
    setVisibility(isOpen);
  }, [isOpen]);

  // change body style
  useEffect(() => {
    document.addEventListener('keydown', handleExitByDOMEvent, false);
    return () => {
      document.removeEventListener('keydown', handleExitByDOMEvent, false);
    };
  });

  // animation
  const animationProps = useSpring({
    from: {
      opacity: isVisible ? 0 : 1,
    },
    to: {
      opacity: isVisible ? 1 : 0,
    },
    onStart: () => {
      if (isVisible) setVisibility(true);
    },
    onRest: () => {
      if (!isVisible) setVisibility(false);
    },
  });

  // handle ok click
  function handleOk() {
    setVisibility(false);
    if (onOk) onOk();
  }

  // render body dialog
  function renderBody() {
    // icon
    const Icon = (props) => iconComponent(props);
    return (
      <Ui.BodyContent>
        <Ui.IconContentPart>
          <Icon size={iconSize} />
        </Ui.IconContentPart>
        <Ui.TextContentPart>
          {text}
        </Ui.TextContentPart>
      </Ui.BodyContent>
    );
  }

  // conditional render
  if (!isVisible) {
    return null;
  }

  return (
    <Ui.Container style={{ ...animationProps, visibility: isVisible ? 'visible' : 'hidden' }}>
      <Ui.Panel>
        <Ui.Body>
          {renderBody()}
        </Ui.Body>
        <Ui.Actions>
          <Button type="button" title={'Ok'} loading={isLoading} onClick={() => handleOk()} />
        </Ui.Actions>
      </Ui.Panel>
    </Ui.Container>
  );
}

// create an hooker to handle PromptConfirm
const usePromptAlert = (() => {
  // states
  const [isOpen, setIsOpen] = useState(false);
  const [onClose, setOnClose] = useState(null);

  const openPromptAlert = useCallback((closeCallback) => {
    setIsOpen(true);
    if (closeCallback) setOnClose(() => closeCallback);
  }, []);

  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
    setIsOpen(false);
  }, [onClose]);

  function renderPromptAlert(icon, text) {
    return (
      <PromptAlert
        isOpen={isOpen}
        iconComponent={icon}
        text={text}
        onOk={handleClose}
      />
    );
  }

  return [
    openPromptAlert,
    renderPromptAlert,
  ];
});

export { PromptAlert, usePromptAlert };
